// The marks on the share buttons.
//
// Emoji were the first version of this and they were the wrong tool twice over: a
// speech bubble is not WhatsApp, a paper plane is not Telegram, and the glyph a
// platform picks for a given emoji is not ours to choose — 💬 came out as a
// different drawing on every system, so "recognisable" was not something the code
// could promise at all.
//
// These are drawn by hand rather than lifted from anybody's brand pack: a circle
// in the service's own colour with the shape of its mark knocked out of it. Simple
// enough to be honest about being an interpretation, close enough that nobody has
// to read the label.
//
// Kept apart from the SOCIAL table in dom.js on purpose. That table is about where
// a button points; this is about what it looks like, and the two change for
// different reasons.

/** Shared wrapper, so every mark is framed the same way whatever is inside it. */
const svg = inner => `<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">${inner}</svg>`;

export const SOCIAL_ICONS = {
  // Green, with the handset: the one everybody knows from a phone.
  whatsapp: svg(`
    <circle cx="12" cy="12" r="10.5" fill="#25D366"/>
    <path fill="#fff" d="M8.2 7.3c.4-.2.8 0 1 .4l1 1.7c.2.4.1.8-.3 1.1l-.8.6c.7 1.5 1.9 2.7 3.4 3.4l.6-.8c.3-.4.7-.5 1.1-.3l1.7 1c.4.2.6.6.4 1-.3.9-1.2 1.6-2.2 1.5-3.6-.3-6.5-3.2-6.8-6.8-.1-1 .5-1.9 1.4-2.2z"/>`),

  // Blue, with the paper plane.
  telegram: svg(`
    <circle cx="12" cy="12" r="10.5" fill="#29A9EB"/>
    <path fill="#fff" d="M18.1 6.6 5.7 11.5c-.6.2-.6.6 0 .8l3.1.9 1.2 3.6c.1.4.4.5.7.2l1.7-1.6 3.1 2.3c.4.3.8.1.9-.5l1.6-9.3c.1-.7-.2-1-.7-.7z"/>`),

  // Blue, with the f. The blue is the whole mark as far as anybody is concerned.
  facebook: svg(`
    <circle cx="12" cy="12" r="10.5" fill="#1877F2"/>
    <path fill="#fff" d="M13.7 20v-6.5h2.2l.4-2.7h-2.6V9.1c0-.8.2-1.3 1.3-1.3h1.4V5.4c-.3 0-1.1-.1-2.1-.1-2.1 0-3.5 1.2-3.5 3.5v2.1H8.6v2.7h2.2V20h2.9z"/>`),

  // Black, with the X. Two strokes, which is the whole logo.
  x: svg(`
    <circle cx="12" cy="12" r="10.5" fill="#0f1419"/>
    <path d="M7.6 7.6 16.4 16.4M16.4 7.6 7.6 16.4" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/>`),

  // The gradient square with the camera in it — the one mark that is a shape
  // rather than a letter, so it keeps its own corners instead of a circle.
  // The gradient has an id because gradients need one; it is the same definition
  // every time it is drawn, so a duplicate costs nothing.
  instagram: svg(`
    <defs><linearGradient id="iggrad" x1="0" y1="1" x2="1" y2="0">
      <stop offset="0" stop-color="#FEDA75"/><stop offset=".35" stop-color="#D62976"/>
      <stop offset=".7" stop-color="#962FBF"/><stop offset="1" stop-color="#4F5BD5"/>
    </linearGradient></defs>
    <rect x="1.6" y="1.6" width="20.8" height="20.8" rx="6.2" fill="url(#iggrad)"/>
    <rect x="6.2" y="6.2" width="11.6" height="11.6" rx="4" fill="none" stroke="#fff" stroke-width="1.7"/>
    <circle cx="12" cy="12" r="3" fill="none" stroke="#fff" stroke-width="1.7"/>
    <circle cx="16.3" cy="7.7" r="1.05" fill="#fff"/>`),

  // Not a network, so not a brand: the two-sheet glyph every desktop has taught
  // people means copy, in the game's own colours rather than somebody else's.
  copy: svg(`
    <circle cx="12" cy="12" r="10.5" fill="#333c5c"/>
    <rect x="9.1" y="4.6" width="10.3" height="10.3" rx="2.2" fill="none" stroke="#dfe6ff" stroke-width="1.6"/>
    <rect x="4.6" y="9.1" width="10.3" height="10.3" rx="2.2" fill="#333c5c" stroke="#dfe6ff" stroke-width="1.6"/>`),
};
